import { forwardRef, useState } from 'react'

import { RefreshCw } from 'lucide-react'

import type { ButtonProps } from '@base-ui/react'
import { useQueryClient } from '@tanstack/react-query'
import { Button } from 'shared/components/ui/button'
import { useTranslate } from 'shared/lib/i18n'
import { cn } from 'shared/lib/utils'

export const RefreshBtn = forwardRef<HTMLButtonElement, ButtonProps>(
	({ className, ...props }, ref) => {
		const { t } = useTranslate()
		const [rotate, setRotate] = useState(0)

		const queryClient = useQueryClient()

		return (
			<Button
				className={cn('max-sm:hidden bg-card', className)}
				variant={'outline'}
				onClick={() => {
					setRotate((p) => p + 360)
					queryClient.invalidateQueries({ type: 'active' })
				}}
				ref={ref}
				{...props}
			>
				<RefreshCw
					style={{ transform: `rotate(${rotate}deg)` }}
					className='mr-1 size-5 transition-transform duration-700'
				/>
				{t('nav.refresh')}
			</Button>
		)
	}
)
